import { fmtDate } from "@/lib/format";

export const KINDS = { contratto: "Contratto", certificazione: "Certificazione", procedura: "Procedura" };
export const STATUS = {
  EXPIRED: ["Scaduto", "bg-red-600 text-white"], TODAY: ["Scade oggi", "bg-red-100 text-red-800"], D7: ["Entro 7 gg", "bg-amber-100 text-amber-900"],
  D30: ["Entro 30 gg", "bg-yellow-50 text-yellow-800"], D60: ["Entro 60 gg", "bg-sky-50 text-sky-800"], VALID: ["Valido", "bg-emerald-50 text-emerald-800"], NONE: ["Senza scadenza", "bg-slate-100 text-slate-600"],
};
export const STATUS_FILTERS = { all: "Tutti gli stati", expired: "Scaduti", soon: "In scadenza (60 gg)", valid: "Validi", none: "Senza scadenza" };
export const matchStatus = (d, f) => f === "all" || (f === "expired" && ["EXPIRED", "TODAY"].includes(d.status)) || (f === "soon" && ["D7", "D30", "D60"].includes(d.status))
  || (f === "valid" && d.status === "VALID") || (f === "none" && d.status === "NONE");
export const dueLabel = (kind) => (kind === "procedura" ? "Prossima revisione" : "Scadenza");

export const StatusBadge = ({ d, testId }) => {
  const [label, cls] = STATUS[d.status] || STATUS.NONE;
  return <span data-testid={testId} className={`whitespace-nowrap px-1.5 py-0.5 text-[11px] font-semibold uppercase ${cls}`}>{label}</span>;
};

export const DaysLeft = ({ d }) => (
  <span className={`font-mono text-xs ${d.days_left != null && d.days_left <= 0 ? "font-bold text-red-700" : d.days_left != null && d.days_left <= 7 ? "text-amber-700" : ""}`}>
    {d.due_date ? fmtDate(d.due_date) : "—"}
    {d.days_left != null && <span className="ml-2 text-muted-foreground">{d.days_left < 0 ? `da ${-d.days_left} gg` : `${d.days_left} gg`}</span>}
  </span>
);
